"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";

import styles from "./Footer.module.scss";
import TwitterIcon from "@/public/social-media/svg/twitter-sm-icon.svg";
import InstagramIcon from "@/public/social-media/svg/instagram-sm-icon.svg";
import LinkedInIcon from "@/public/social-media/svg/linkedin-sm-icon.svg";
import YoutubeIcon from "@/public/social-media/svg/youtube-sm-icon.svg";
import DatamuniIcon from "@/public/common/svg/datamuni-icon-black.svg";
import { SOCIAL_MEDIA_LINKS } from "@constants/constants";

const Footer: React.FC = () => {
    const openLink = (url: string) => {
        window.open(url, "_blank"); // Opens the link in a new tab
    };

    return (
        <>
            <footer className={styles.footer}>
                <div className={styles.heading}>
                    <Image
                        src={"/common/svg/datamuni-icon-black.svg"}
                        alt="Datamuni Logo"
                        className={styles.logoIcon}
                        width={50}
                        height={50}
                    />
                    <span className={styles.brandName}>Datamuni</span>
                </div>

                <div className={styles.socialContainer}>
                    <div className={styles.socialIcons}>
                        <div
                            className={styles.iconLink}
                            onClick={() => openLink(SOCIAL_MEDIA_LINKS.TWITTER)}
                        >
                            <Image
                                src={"/social-media/svg/twitter-sm-icon.svg"}
                                alt="Twitter Icon"
                                className={styles.icon}
                                width={24}
                                height={24}
                            />
                            <span className={styles.iconLabel}>
                                @thedatamuni
                            </span>
                        </div>
                        <div
                            className={styles.iconLink}
                            onClick={() =>
                                openLink(SOCIAL_MEDIA_LINKS.INSTAGRAM)
                            }
                        >
                            <Image
                                src={"/social-media/svg/instagram-sm-icon.svg"}
                                alt="Instagram Icon"
                                className={styles.icon}
                                width={24}
                                height={24}
                            />
                            <span className={styles.iconLabel}>
                                @thedatamuni
                            </span>
                        </div>
                        <div
                            className={styles.iconLink}
                            onClick={() =>
                                openLink(SOCIAL_MEDIA_LINKS.LINKEDIN)
                            }
                        >
                            <Image
                                src={"/social-media/svg/linkedin-sm-icon.svg"}
                                alt="LinkedIn Icon"
                                className={styles.icon}
                                width={24}
                                height={24}
                            />
                            <span className={styles.iconLabel}>
                                @thedatamuni
                            </span>
                        </div>
                        <div className={styles.iconLink}>
                            <Image
                                src={"/social-media/svg/youtube-sm-icon.svg"}
                                alt="YouTube Icon"
                                className={styles.icon}
                                width={24}
                                height={24}
                            />
                            <span className={styles.iconLabel}>
                                @thedatamuni
                            </span>
                        </div>
                    </div>
                </div>
                <div className={styles.footerBottom}>
                    <p>Copyright © 2024 Datamuni</p>
                    <div className={styles.links}>
                        <h4> All rights Reserved |</h4>
                        <Link href="/terms-of-services" passHref>
                            <span style={{ cursor: "pointer" }}>
                                Terms and Conditions
                            </span>
                        </Link>
                        <span> | </span>
                        <Link href="/privacy-policy" passHref>
                            <span style={{ cursor: "pointer" }}>
                                Privacy Policy
                            </span>
                        </Link>
                        <span>|</span>

                        <span style={{ cursor: "pointer" }}>Disclaimer</span>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer;
